import { useReduxSelector } from 'shared/hooks/useReduxSelector';
import { coworkingMinPriceSelector } from 'shared/store/coworking/selectors/dump/coworkingMinPriceSelector';

/**
 * @description не требуется тестирование, так как тестировать нечего
 */
/* istanbul ignore next */
export function useCoworkingMinPriceSelector(): number | null {
  return useReduxSelector<number | null>(coworkingMinPriceSelector);
}
